import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import userStore from '../../store/user/user-store'
import ReactButton from './ReactButton.vue'

@Component({
  name: 'trustButton',
  props: ['user'],
  components: { 'react-button' : ReactButton }
})
export default class TrustButton extends Vue {

  protected followUser (): void {
    userStore.dispatchFollowUser(this.$props['user'])
  }

  protected unfollowUser (): void {
    userStore.dispatchUnfollowUser(this.$props['user'])
  }

}
